<div id="asset-editor-container" *ngIf="!loading; else loadingTemplate">
  <h1>{{ title }}</h1>
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="brd-tab-group">
    <form [formGroup]="formGroup" *ngIf="formGroup">
      <mat-tab label="Identity" labelClass="brd-tab-label-class" bodyClass="brd-tab-body-class">
        <div class="indentity-form-tab">
          <dx-text-box
            formControlName="name"
            label="Name*"
            labelMode="floating"
            stylingMode="outlined"
            [validationStatus]="formGroup.controls.name.errors && formGroup.controls.name.touched ? 'invalid' : 'valid'"
            [validationErrors]="[{ type: 'required', message: 'Name is mandatory!' }]"
          ></dx-text-box>
          <dx-text-area formControlName="description" label="Description" labelMode="floating" stylingMode="outlined"></dx-text-area>
          <dx-tag-box
            *ngIf="industries$ | async as industries"
            formControlName="industries"
            label="Applicable industries"
            labelMode="floating"
            stylingMode="outlined"
            [dataSource]="industries"
            displayExpr="name"
            [acceptCustomValue]="true"
            (onCustomItemCreating)="customItemIndustry($event)"
          ></dx-tag-box>
          <brd-asset-category-editor *ngIf="categories$ | async as categories" formControlName="categoryId" [categories]="categories">
          </brd-asset-category-editor>
          <dx-number-box
            formControlName="ramConsumption"
            label="Ram consumption (MB)*"
            labelMode="floating"
            stylingMode="outlined"
            [min]="0"
            [validationStatus]="ramConsumptionValidator().isValid ? 'valid' : 'invalid'"
            [validationErrors]="[{ message: ramConsumptionValidator().message }]"
          ></dx-number-box>
          <dx-number-box
            formControlName="diskConsumption"
            label="Disk consumption (MB)*"
            labelMode="floating"
            stylingMode="outlined"
            [min]="0"
            [validationStatus]="diskConsumptionValidator().isValid ? 'valid' : 'invalid'"
            [validationErrors]="[{ message: diskConsumptionValidator().message }]"
          ></dx-number-box>
          <dx-text-box formControlName="version" label="Version" labelMode="floating" stylingMode="outlined"></dx-text-box>
          <dx-date-box
            formControlName="lastUpdate"
            label="Last update"
            labelMode="floating"
            stylingMode="outlined"
            type="date"
            displayFormat="MM/dd/yyyy"
          ></dx-date-box>
          <div class="custom-checkbox">
            <span class="custom-label">Mark as Default</span>
            <dx-check-box formControlName="default"></dx-check-box>
          </div>
          <h3>Environment variables</h3>
          <div>
            <dx-toolbar [items]="toolbarItems"></dx-toolbar>
            <dx-data-grid #envVarsGrid [(dataSource)]="formGroup.controls.envVars.value" [columns]="columnsEnvVars" [showBorders]="true">
              <dxo-editing [allowUpdating]="true" [allowDeleting]="true" [useIcons]="true" mode="cell" newRowPosition="last"></dxo-editing>
            </dx-data-grid>
          </div>
          <h3>Enablement material</h3>
          <div>
            <dx-toolbar [items]="toolbarItemsMaterials"></dx-toolbar>
            <dx-data-grid
              #materialsGrid
              [(dataSource)]="formGroup.controls.materials.value"
              [columns]="columnsMaterials"
              [showBorders]="true"
            >
              <dxo-editing [allowUpdating]="true" [allowDeleting]="true" [useIcons]="true" mode="popup" newRowPosition="last">
                <dxo-popup title="Module material" [showTitle]="true" [width]="550" [height]="450"> </dxo-popup>
                <dxo-form>
                  <dxi-item itemType="group" [colCount]="1" [colSpan]="2">
                    <dxi-item
                      dataField="type"
                      [label]="{ text: 'Type', visible: false }"
                      [editorOptions]="{ stylingMode: 'outlined', labelMode: 'floating' }"
                    ></dxi-item>
                    <dxi-item
                      dataField="name"
                      [label]="{ text: 'Name', visible: false }"
                      [editorOptions]="{ stylingMode: 'outlined', labelMode: 'floating' }"
                    ></dxi-item>
                    <dxi-item
                      dataField="url"
                      [label]="{ text: 'Link', visible: false }"
                      [editorOptions]="{ stylingMode: 'outlined', labelMode: 'floating' }"
                    ></dxi-item>
                  </dxi-item>
                </dxo-form>
              </dxo-editing>
              <div *dxTemplate="let d of 'mediaTemplate'">
                <a [href]="d.data.url" target="_blank"> {{ d.data.name }} </a>
              </div>
            </dx-data-grid>
          </div>
          <h3>Demo source*</h3>
          <brd-file-uploader
            formControlName="demoSource"
            fileExtensionsAccepted=".7z"
            [status]="formGroup.controls.demoSource.errors && formGroup.controls.demoSource.touched ? 'invalid' : 'valid'"
            errorMessage="Demo capsule and database are mandatory"
            [maxFileSize]="maxPresetSize"
          >
          </brd-file-uploader>
          <h3>GenAI Configuration</h3>
          <brd-file-uploader formControlName="agentsConfig" fileExtensionsAccepted=".txt" [allowMultipleFiles]="true"> </brd-file-uploader>
        </div>
      </mat-tab>
      <mat-tab label="Media" labelClass="brd-tab-label-class" bodyClass="brd-tab-body-class">
        <div class="indentity-form-tab">
          <h3>Placeholder image</h3>
          <brd-file-uploader
            formControlName="defaultImage"
            fileExtensionsAccepted=".jpg,.png,.gif"
            type="image"
            [maxFileSize]="maxImageSize"
            [srcPreviewInput]="imagePreviewInput"
          ></brd-file-uploader>
          <h3>Hover image</h3>
          <brd-file-uploader
            formControlName="hoveredImage"
            fileExtensionsAccepted=".jpg,.png,.gif"
            type="image"
            [maxFileSize]="maxImageSize"
            [srcPreviewInput]="hoverPreviewInput"
          ></brd-file-uploader>
          <h3>Carousel</h3>
          <brd-carousel-uploader formControlName="slides" [initSources]="initSources"></brd-carousel-uploader>
        </div>
      </mat-tab>
    </form>
    <mat-tab label="Modules" labelClass="brd-tab-label-class" bodyClass="brd-tab-body-class">
      <div class="modules-container">
        <div class="modules-list-container">
          <dx-list
            [dataSource]="modulesDataSource"
            displayExpr="text"
            selectionMode="single"
            [selectByClick]="true"
            [allowItemDeleting]="true"
            (onSelectionChanged)="moduleSelectionChanged($event)"
          >
            <dxo-item-dragging group="tasks" [data]="modulesFormGroup" [allowReordering]="true"></dxo-item-dragging>
          </dx-list>
          <dx-button stylingMode="outlined" type="normal" [width]="120" (onClick)="addModule()">ADD MODULE</dx-button>
        </div>
        <div class="modules-form-container">
          <ng-container *ngFor="let module of moduelsListValues">
            <brd-module-editor *ngIf="selectedGuid === module.id" [moduleFormGroup]="module.form"></brd-module-editor>
          </ng-container>
          <div *ngIf="!selectedGuid" style="margin: 1rem">No module selected.</div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Suggested demos" labelClass="brd-tab-label-class" bodyClass="brd-tab-body-class" [disabled]="formGroup.value.default">
      <form [formGroup]="suggestedFormgGroup" *ngIf="suggestedFormgGroup" class="indentity-form-tab">
        <brd-suggested-editor
          *ngIf="assets$ | async as assets"
          [assets]="assets"
          formControlName="suggestedDemos"
          [baseRamConsumption]="formGroup.value.ramConsumption"
          [baseDiskConsumption]="formGroup.value.diskConsumption"
        ></brd-suggested-editor>
      </form>
    </mat-tab>
    <mat-tab label="Authorization" labelClass="brd-tab-label-class" bodyClass="brd-tab-body-class">
      <div class="indentity-form-tab">
        <strong *ngIf="disableAcl()" class="warning-message">Attention! Default demo assets are always available to everyone.</strong>
        <mat-radio-group color="primary" class="acl-radio-group" (change)="selectedAcl = $event.value" [disabled]="disableAcl()">
          <h3>Demo Asset access:</h3>
          <mat-radio-button *ngFor="let acl of aclValues" [value]="acl.value" [checked]="selectedAcl === acl.value">
            {{ acl.text }}
          </mat-radio-button>
        </mat-radio-group>
        <div *ngIf="selectedAcl === selectedGroupEnumValue" class="acl-grid-container">
          <brd-sfaccount-grid [selectedGroups]="selectedAclGroups" [exportOptions]="exportOptions"></brd-sfaccount-grid>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
  <div class="action-bar">
    <div class="total-consumption">
      <div>Consumptions:</div>
      <div>
        RAM <strong>{{ totalConsumption().ram }}</strong> of <strong>{{ totalConsumption().maxRam }}</strong> - Disk
        <strong>{{ totalConsumption().disk }}</strong> of <strong>{{ totalConsumption().maxDisk }}</strong>
      </div>
    </div>
    <dx-button stylingMode="text" type="danger" [width]="120" (onClick)="cancel()">CANCEL</dx-button>
    <dx-button *ngIf="canDownloadZip" stylingMode="text" type="default" (onClick)="downlaodZip()">DOWNLOAD ZIP</dx-button>
    <dx-button stylingMode="text" type="default" [width]="150" (onClick)="saveAsset(true)"> SAVE AS DRAFT </dx-button>
    <dx-button stylingMode="contained" type="default" [width]="120" (onClick)="saveAsset()">SUBMIT</dx-button>
  </div>
</div>
<div class="submitting" *ngIf="submitting">
  <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
</div>
<ng-template #loadingTemplate>
  <div class="loader-container">
    <mat-progress-spinner diameter="60" mode="indeterminate" strokeWidth="5"></mat-progress-spinner>
  </div>
</ng-template>
